export default __webpack_public_path__ + "static/media/connection-result-image.d4f31a84.svg";